export const ATTESTATION_EVIDENCE_LABELS = {
  attestation: 'Attestation',
  goToActivity: 'Go to activity',
  copyQuotes: 'Copy quotes',
  quotesCopied: 'Quotes copied to clipboard',
} as const
